import React, { useEffect, useRef, useState } from "react";
import { faAngleLeft, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row } from "reactstrap";
import { useReactToPrint } from "react-to-print";
import moment from "moment/moment";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { useLocation, useNavigate } from "react-router-dom";

//API
import fiscalizacao_api from "../../../api/fiscalizacao_api";

//Helpers
import { showMessage } from "../../../helpers/message";
import { formatDataHora } from "../../../helpers/formatDataHora";

//Context
import { useAuth } from "../../../context/auth";

//Components
import TabelaListagemFichas from "../../../components/TabelaListagemFichas/TabelaListagemFichas";
import FichaInfracao from "../FichaInfracao";
import mascaras from "../../../helpers/mascaras";

//Estilo da pagina de impressão
const pageStyle = `
@page { 
  size: auto;  margin: 0mm ;
} 
@media print { 
    body { -webkit-print-color-adjust: exact; } 
}
@media print {
  @page{
    size:A4;
    margin:0;
  }
  .relatorio {
    width: 100vw!important;
    display:flex;
    flex-direction:column;
  }
  div.header{
    display:table-header-group;
  }
  div.body{
    display:table-row-group;
  }
}
`;

function AutoDeFiscalizacao({ fichaExterna = null, preview = false, hiddenButtonImprimir = false }) {
  //State para lista de fiscalização
  const [fiscalizacao, setfiscalizacao] = useState(fichaExterna);

  const { setLoading, logoSistema, logoSecretaria, logoPrefeitura, session } =
    useAuth();

  //Referencia para o componente de impressão
  const ref = useRef(null);

  const location = useLocation();

  const navigate = useNavigate();

  //pegando a etapa selecionada no dashboard
  const { fiscalizacao_id, btnVoltar, numeroInfracao, stackRoutes } =
    location.state ? location.state : {};

  //Cabeçalhos da lista de formulario fiscalização
  const headersFormularioFiscalização = [
    { value: "Condutas e Providências", objectValue: "questao", align: "left" },
    { value: "Resposta", objectValue: "resposta", align: "left" },
    { value: "Anexo", objectValue: "anexos", align: "left" },
  ];

  //Cabeçalhos da lista de lista infraões
  const headersListaInfracoes = [
    { value: "Infração", objectValue: "infracao_Identificacao", align: "left" },
    { value: "Tipo de Penalidade", objectValue: "tipoInfracao", align: "left" },
    { value: "Situação", objectValue: "situacao", align: "left" },
    { value: "Número infração", objectValue: "numeroInfracao", align: "left" },
    { value: "Proxima Ação", objectValue: "prazoProximaAcao", align: "left" },
  ];

  // Na prévia a infração ainda não existe: sem situação, número ou prazo definidos.
  const headersListaInfracoesPreview = [
    { value: "Infração", objectValue: "infracao_Identificacao", align: "left" },
    { value: "Tipo de Penalidade", objectValue: "tipoInfracao", align: "left" },
  ];

  //Cabeçalhos da lista de lista infraões
  const headersListaAgrupamento = [
    {
      value: "Data cadastro",
      objectValue: "dataCadastro",
      formatDate: true,
      align: "left",
    },
    { value: "Origem", objectValue: "origem", align: "left" },
    { value: "Status", objectValue: "status", align: "left" },
    { value: "Agrupado", objectValue: "agrupado", align: "left" },
  ];

  //Função para pegar a fiscalização
  const loadFiscalizacaoItem = () => {
    if (fiscalizacao_id != null) {
      setLoading(true);
      fiscalizacao_api
        .getItem(fiscalizacao_id)
        .then((response) => {
          response.data?.infracoes?.map((v) => {
            v.prazoProximaAcao = moment(v.prazoProximaAcao).format(
              "DD/MM/YYYY"
            );
            return v;
          });
          setfiscalizacao(response.data);
        })
        .catch((error) => showMessage("aviso", error.message, "error", null))
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    if (!preview) loadFiscalizacaoItem(fiscalizacao_id);
  }, [fiscalizacao_id]);

  const handleVisualizarDemanda = (id) => {
    const _location = { ...location.state };
    delete _location.btnVoltar;

    navigate("/admin/demandas/ficha-demanda", {
      state: {
        ..._location,
        id: id,
        fiscalizacao_id: location.state.fiscalizacao_id,
      },
    });
  };

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    copyStyles: true,
    documentTitle: "Fiscalizacação",
    pageStyle: pageStyle,
  });

  return (
    <>
      <div style={{ color: "#666" }}>
        {!preview && (
          <div className="d-flex justify-content-between align-items-center documentoImpressao">
            {session != null && !fichaExterna && (
              <Button
                onClick={() => {
                  if (!!stackRoutes && stackRoutes.length > 0) {
                    navigate("/admin/ficha-infracao", {
                      state: {
                        ...location.state,
                        infracao_id: stackRoutes[stackRoutes.length - 1],
                        btnVoltar: "/admin/ficha-Fiscalizacao",
                        originPath: location.state.originPath
                          ? location.state.originPath
                          : "/admin/ficha-Fiscalizacao",
                        stackRoutes: stackRoutes.filter(
                          (v, i) => i != stackRoutes.length - 1
                        ),
                      },
                    });
                  } else {
                    //CE-3639: respeita a tela de origem quando informada.
                    navigate(btnVoltar ?? "/admin/consultaFiscalizacao", {
                      state: { ...location.state },
                    });
                  }
                }}
              >
                <FontAwesomeIcon icon={faAngleLeft} /> Voltar
              </Button>
            )}
            {!hiddenButtonImprimir && (
              <Button color="danger" onClick={handlePrint}>
                <FontAwesomeIcon icon={faFilePdf} /> Imprimir
              </Button>
            )}
          </div>
        )}
        <div
          className={`bg-white p-3 mt-3 rounded shadowFicha mainContainerFicha`}
          ref={ref}
        >
          <div className="d-flex justify-content-between align-items-center w-100">
            {logoSistema && (
              <div>
                <img src={logoSistema} width={180} alt="logo do sistema" />
              </div>
            )}
            {logoSecretaria && (
              <div>
                <img
                  src={logoSecretaria}
                  className="mt-3"
                  width={140}
                  alt="logo do sistema"
                />
                <img
                  src={logoPrefeitura}
                  width={120}
                  alt="logo da prefeitura"
                />
              </div>
            )}
          </div>
          <div className="bw-bold d-flex justify-content-center align-items-start flex-column mb-3">
            <h2>Auto de Fiscalização</h2>
            <div className="d-flex gap-3">
              <span className="fw-regular">
                <span className="fw-bold">Número da Fiscalização:</span>{" "}
                {fiscalizacao?.numeroFiscalizacao}{" "}
              </span>
              <span className="fw-regular">
                <span className="fw-bold">Data:</span>{" "}
                {moment(new Date()).format("DD/MM/YYYY")}
              </span>
            </div>
          </div>
          <div className="shadowFicha rounded-3">
            <h5 className="p-2 titleFicha">Identificação da Fiscalização</h5>
            <Row className="px-3 py-2">
              <Col md="4" lg="6" className="mb-2">
                <span className="fw-bold">Endereço da infração: </span>{" "}
                {fiscalizacao?.enderecoCompleto ?? ""}
              </Col>
              <Col md="4" lg="3" className="mb-2">
                <span className="fw-bold">Data da Infração: </span>
                {formatDataHora(fiscalizacao?.dataFlagrande)}
              </Col>
              <Col md="4" lg="3" className="mb-2">
                <span className="fw-bold">Data do Registro: </span>{" "}
                {formatDataHora(fiscalizacao?.dataFiscalizacao)}
              </Col>
              <Col md="4" lg="4" className="mb-2">
                <span className="fw-bold">Situação: </span>{" "}
                {fiscalizacao?.situacao ?? ""}
              </Col>
              <Col md="4" lg="4" className="mb-2">
                <span className="fw-bold">Código do Item: </span>{" "}
                {fiscalizacao?.codigoItem ?? ""}
              </Col>
              <Col md="4" lg="4" className="mb-2">
                <span className="fw-bold">Regional: </span>{" "}
                {fiscalizacao?.regional ?? ""}
              </Col>
              {fiscalizacao?.demanda_Id && (
                <Col md="4" lg="4" className="mb-2">
                  <span className="fw-bold">Demanda Id: </span>{" "}
                  {fiscalizacao?.demanda_Id ?? ""}
                </Col>
              )}
            </Row>
          </div>
          {session != null && !preview && (
            <div className="mt-4 shadowFicha rounded-3">
              <h5 className="p-2 titleFicha">Identificação do Denunciante</h5>
              <Row className="px-3 py-2">
                <Col md="6" lg="4" className="mb-2">
                  <span className="fw-bold">Nome: </span>{" "}
                  {fiscalizacao?.denunciante_Nome ?? ""}
                </Col>
                <Col md="6" lg="4" className="mb-2">
                  <span className="fw-bold">Email: </span>{" "}
                  {fiscalizacao?.denunciante_Email ?? ""}
                </Col>
                <Col md="6" lg="4" className="mb-2">
                  <span className="fw-bold">Telefone: </span>{" "}
                  {fiscalizacao?.denunciante_Telefone ?? ""}
                </Col>
                <Col md="6" lg="12" className="mb-2">
                  <span className="fw-bold">Observação: </span>{" "}
                  {fiscalizacao?.solicitacao_Observacoes ?? ""}
                </Col>
              </Row>
            </div>
          )}

          <div className="mt-4 shadowFicha rounded-3">
            <h5 className="p-2 titleFicha">Identificação do Infrator</h5>
            <Row className="px-3 py-2">
              <Col md="12" lg="6" classNam e="mb-2">
                <span className="fw-bold">Nome / Razão social: </span>{" "}
                {fiscalizacao?.infrator?.nome ?? ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Nome Fantasia: </span>{" "}
                {fiscalizacao?.infrator?.fantasia ?? ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">CPF/CNPJ: </span>{" "}
                {fiscalizacao?.infrator?.documentoIdentificacao ?? ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Email: </span>{" "}
                {fiscalizacao?.infrator?.email ?? ""}
              </Col>
              <Col md="12" lg="6" className="mb-2">
                <span className="fw-bold">Código de cadastro: </span>{" "}
                {fiscalizacao?.infrator?.codigoCadastro ?? ""}
              </Col>
              {fiscalizacao?.infrator?.emailsCC &&
                !!fiscalizacao?.infrator?.emailsCC.length > 0 && (
                  <Col md="12" lg="12">
                    <span className="fw-bold">Emails CC: </span>{" "}
                    {fiscalizacao?.infrator?.emailsCC.join("; ") ?? ""}
                  </Col>
                )}
            </Row>
            <Row className="px-3">
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">CEP: </span>{" "}
                {fiscalizacao?.infrator?.cep
                  ? mascaras.cepMask(fiscalizacao?.infrator?.cep)
                  : ""}
              </Col>
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">Cidade: </span>{" "}
                {fiscalizacao?.infrator?.cidade ?? ""}
              </Col>
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">UF: </span>{" "}
                {fiscalizacao?.infrator?.uf ?? ""}
              </Col>
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">Logradouro: </span>{" "}
                {fiscalizacao?.infrator?.logradouro ?? ""}
              </Col>
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">Bairro: </span>{" "}
                {fiscalizacao?.infrator?.bairro ?? ""}
              </Col>
              <Col md="12" lg="4" className="mb-2">
                <span className="fw-bold">Número: </span>{" "}
                {fiscalizacao?.infrator?.numero ?? ""}
              </Col>
              {!!fiscalizacao?.infrator?.complemento && (
                <Col md="12" lg="12" className="mb-2">
                  <span className="fw-bold">Complemento: </span>{" "}
                  {fiscalizacao?.infrator?.complemento ?? ""}
                </Col>
              )}

              {fiscalizacao?.assinaturaInfrator && (
                <>
                  <Col md="12" lg="12" className="mb-2">
                    <span className="fw-bold">Assinatura Digital: </span>
                  </Col>
                  <Col
                    md="12"
                    lg="12"
                    className="mb-2 d-flex justify-content-center"
                  >
                    <img
                      width={"300px"}
                      height={"150"}
                      className="text-center"
                      src={
                        "data:image/png;base64," +
                        fiscalizacao?.assinaturaInfrator
                      }
                    />
                  </Col>
                </>
              )}
            </Row>
          </div>

          <div className="shadowFicha rounded-3 mt-4">
            <h5 className="p-2 titleFicha">Imagens da fiscalização</h5>
            <div className="d-flex gap-3 justify-content-center flex-wrap px-2 py-2">
              {fiscalizacao?.anexosSolicitacoes?.map((value, key) => (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  key={key}
                >
                  <a
                    href={value.anexo}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="rounded"
                      src={value.anexo}
                      alt="Imagem da solicitação fiscalização"
                      width={150}
                      height={200}
                    />
                  </a>
                  <span
                    className="bg-secondary text-white p-1 mt-2 rounded-3"
                    style={{ fontSize: "8pt" }}
                  >
                    Imagem da demanda
                  </span>
                </div>
              ))}
            </div>
          </div>

          {fiscalizacao?.dadosSolicitacaoFiscalizacaoFalecidos && (
            <>
              <div className="mt-4 shadowFicha rounded-3">
                <h5 className="p-2 titleFicha">
                  Dados do Falecido informados na Solicitação de Vistoria
                </h5>
                <Row className="px-3 py-2">
                  <Col md="12" lg="12" className="mb-2">
                    <span className="fw-bold"> Nome: </span>{" "}
                    {fiscalizacao?.dadosSolicitacaoFiscalizacaoFalecidos
                      ?.nome ?? ""}
                  </Col>
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Data de Nascimento: </span>{" "}
                    {fiscalizacao?.dadosSolicitacaoFiscalizacaoFalecidos
                      ?.dataNascimento
                      ? moment(
                        fiscalizacao?.dadosSolicitacaoFiscalizacaoFalecidos
                          ?.dataNascimento
                      ).format("DD/MM/YYYY")
                      : ""}
                  </Col>
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Data de Falecimento: </span>{" "}
                    {fiscalizacao?.dadosSolicitacaoFiscalizacaoFalecidos
                      ?.dataFalecimento
                      ? moment(
                        fiscalizacao?.dadosSolicitacaoFiscalizacaoFalecidos
                          ?.dataFalecimento
                      ).format("DD/MM/YYYY")
                      : ""}
                  </Col>
                </Row>
              </div>
            </>
          )}

          {fiscalizacao?.dadosObito && (
            <>
              <div className="mt-4 shadowFicha rounded-3">
                <h5 className="p-2 titleFicha">Dados do Óbito</h5>
                <Row className="px-3 py-2">
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold"> Nome: </span>{" "}
                    {fiscalizacao?.dadosObito?.nome ?? ""}
                  </Col>
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">CPF: </span>{" "}
                    {fiscalizacao?.dadosObito?.cpf
                      ? mascaras.cpfMask(fiscalizacao.dadosObito.cpf)
                      : ""}
                  </Col>
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Data de Nascimento: </span>{" "}
                    {fiscalizacao?.dadosObito?.dataNascimento
                      ? moment(fiscalizacao?.dadosObito?.dataNascimento).format(
                        "DD/MM/YYYY"
                      )
                      : ""}
                  </Col>
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Data de Falecimento: </span>{" "}
                    {fiscalizacao?.dadosObito?.dataFalecimento
                      ? moment(
                        fiscalizacao?.dadosObito?.dataFalecimento
                      ).format("DD/MM/YYYY")
                      : ""}
                  </Col>
                </Row>
              </div>
            </>
          )}

          {!!fiscalizacao?.planoTrabalhoLocal &&
            !!fiscalizacao?.planoTrabalhoLocal?.latitude &&
            !!fiscalizacao?.planoTrabalhoLocal?.longitude && (
              <div className="contentGroup shadowFicha rounded-3 mt-4">
                <h5 className="p-2 titleFicha">Plano de trabalho</h5>
                <Row className="px-3">
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Identificação: </span>{" "}
                    {fiscalizacao.planoTrabalhoLocal.identificacao}
                  </Col>
                  <Col md="12" lg="6" className="mb-2">
                    <span className="fw-bold">Endereço da infração: </span>{" "}
                    {fiscalizacao.planoTrabalhoLocal.enderecoCompleto}
                  </Col>
                </Row>
                <div
                  style={{ height: "250px", position: "relative" }}
                  className="px-3 py-2"
                >
                  <MapContainer
                    center={[
                      fiscalizacao.planoTrabalhoLocal.latitude,
                      fiscalizacao.planoTrabalhoLocal.longitude,
                    ]}
                    style={{ height: "100%", width: "100%" }}
                    zoom={20}
                  >
                    <TileLayer
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker
                      position={[
                        fiscalizacao.planoTrabalhoLocal.latitude,
                        fiscalizacao.planoTrabalhoLocal.longitude,
                      ]}
                    ></Marker>
                  </MapContainer>
                </div>
              </div>
            )}

          <div className="mt-4 shadowFicha rounded-3">
            <h5 className="p-2 titleFicha">
              Apontamentos da Fiscalização e Questão
            </h5>
            {fiscalizacao && fiscalizacao?.formulario?.length > 0 && (
              <Row className="px-3 py-2">
                <TabelaListagemFichas
                  headers={headersFormularioFiscalização}
                  items={fiscalizacao.formulario}
                  scrollbar={false}
                  widthPDF="60%"
                />
              </Row>
            )}
          </div>

          {fiscalizacao &&
            fiscalizacao?.solicitacoesAgrupamentos?.length > 0 && (
              <div className="mt-4 shadowFicha rounded-3">
                <h5 className="p-2 titleFicha">Demanda Agrupadas</h5>
                <Row className="px-3 py-2">
                  <TabelaListagemFichas
                    visualizar={(item) => handleVisualizarDemanda(item.id)}
                    headers={headersListaAgrupamento}
                    items={fiscalizacao.solicitacoesAgrupamentos}
                    scrollbar={false}
                  />
                </Row>
              </div>
            )}

          <div className="mt-4 shadowFicha rounded-3">
            <h5 className="p-2 titleFicha">Lista de Infrações</h5>
            {fiscalizacao && fiscalizacao?.infracoes?.length > 0 && (
              <Row className="px-3 py-2">
                <TabelaListagemFichas
                  visualizar={
                    preview
                      ? undefined
                      : (item) => {
                          if (!!fichaExterna && item.hash)
                            navigate(
                              `/auth/consultaInfracaoMunicipe?hash=${item.hash}`
                            );
                          else if (
                            !!stackRoutes &&
                            stackRoutes[stackRoutes.length - 1] == item.id
                          ) {
                            navigate(-1);
                          } else {
                            navigate("/admin/ficha-infracao", {
                              state: {
                                ...location.state,
                                infracao_id: item.id,
                                btnVoltar: "/admin/ficha-Fiscalizacao",
                              },
                            });
                          }
                        }
                  }
                  headers={preview ? headersListaInfracoesPreview : headersListaInfracoes}
                  items={fiscalizacao.infracoes}
                  scrollbar={false}
                />
              </Row>
            )}
          </div>
          {session != null && (
            <div className="mt-4 shadowFicha rounded-3">
              <h5 className="p-2 titleFicha">Identificação do Fiscal</h5>
              <Row className="px-3 py-2">
                <Col md="12" lg="4" className="mb-2">
                  <span className="fw-bold">Fiscal: </span>{" "}
                  {fiscalizacao?.usuario_Nome ?? ""}
                </Col>
                {fiscalizacao?.registroFuncional && (
                  <Col md="12" lg="4" className="mb-2">
                    <span className="fw-bold">Registro Funcional(RF): </span>{" "}
                    {fiscalizacao?.registroFuncional ?? ""}
                  </Col>
                )}
                {fiscalizacao?.dataHoraPreenchimento && (
                  <Col md="12" lg="4" className="mb-2">
                    <span className="fw-bold">Data/Hora Lavratura: </span>{" "}
                    {formatDataHora(fiscalizacao?.dataHoraPreenchimento)}
                  </Col>
                )}
              </Row>
            </div>
          )}
          <div className="rodapeDocumento">
            <div className="print m-2 d-flex align-items-center justify-content-between">
              <p>Auto de Infração e Sanção: {numeroInfracao}</p>
              <p>
                documento original extraído do sistema FiscSP, em{" "}
                {moment().format("DD/MM/YYYY")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AutoDeFiscalizacao;
